import { AppColors } from "../../assets/styles/colors";

export const componentStyles = {
  button1: {
    backgroundColor: "#E65088",
    color: "white",
    marginTop: 10,
  },

  button2: {
    border: "1px solid #E65088",
    color: "#E65088",
    marginLeft: 10,
    marginTop: 10,
  },
  button3: {
    border: "1px solid #E65088",
    backgroundColor: "#E65088",
    color: "#fff",
    marginTop: 50,
  
  },
  imageStyle: {
    marginTop: 60,
    width: 803,
    height: "60dvh",
  },

  spacingBottom: {
    marginBottom: 20,
  },

  titleStyle: {
    fontWeight: 700,
    color: "#476788",
  },

};
